import React, { useState } from "react";
import { Button } from "controls";
import { action, API, controller } from "api";
import { ToFormData } from "hooks";
import { toast } from "react-toastify";
import InputCategory from "../Form/QuickAdding/InputCategory";

const UpdateCategory = ({ selectedRec, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({ catId: "", subCatId: "" });

  const handleInpChg = (e) => {
    setValues((j) => ({ ...j, [e.target.name]: e.target.value }));
  };

  const handleSubmit = () => {
    setLoading(true);
    API(controller.Product + action.UpdateBCST).post(
      ToFormData({
        all: selectedRec?.all,
        ids: selectedRec?.items,
        type: "category",
        catId: values.catId,
        subCatId: values.subCatId,
      }),
      (res) => {
        if (res?.status === 200) toast.success(res.msg);
        setLoading(false);
        handleClose();
      }
    );
  };

  return (
    <div className="pt-4 flex flex-col gap-5">
      <InputCategory {...{ handleInpChg, values, setValues }} size="large" />

      <div className="flex justify-end gap-2">
        <Button
          onClick={handleClose}
          variant="text"
          size="large"
          className="!min-w-[130px]"
        >
          Don't Update
        </Button>
        <Button size="large" loading={loading} onClick={handleSubmit}>
          Update Categories
        </Button>
      </div>
    </div>
  );
};

export default UpdateCategory;
